import * as t from "io-ts";
export const TABS = {
	DASHBOARD: "dashboard",
	FUNDING_ROUNDS: "funding-rounds",
	INVESTMENT_TRENDS: "investment-trends",
	INVESTORS: "investors",
	UNICORNS: "unicorns",
	PEOPLE: "people",
	PROFILE: "profile",
};
export const TAG = {
	OXBRIDGE_BEYOND: "Oxbridge & Beyond",
	UNICORN_ALUMNI: "Unicorn Alumni",
	BIG_FOUR_VETERANS: "Big Four Veterans",
	AI_PIONEERS: "AI Pioneers",
	WEB3_BUILDERS: "Web3 Builders",
	ESG: "ESG",
	CREATIVE_POWERHOUSES: "Creative Powerhouses",
	RESEARCH_WIZARDS: "Research Wizards",
	SERIAL_FOUNDERS: "Serial Founders",
	HYPERGROWTH_NAVIGATORS: "Hypergrowth Navigators",
	REGIONAL_STARS: "Regional Stars",
	STUDENT_VISIONARIES: "Student Visionaries",
	FREELANCE_MAVERICKS: "Freelance Mavericks",
	SCALEUP_HEROES: "Scale-Up Heroes",
	TECH_POLICYMAKERS: "Tech Policymakers",
	ECOSYSTEM_CONNECTORS: "Ecosystem Connectors",
	PRIOR_EXITS: "Prior Exits",
	DEEP_TECHNOLOGY_BACKGROUND: "Deep Technology Background",
	PRIOR_VC_BACKED_FOUNDER: "Prior VC-Backed Founder",
	VENTURE_BACKED: "Venture Backed",
	NORTHERN_REGION: "Northern Region",
	EASTERN_REGIONS: "Eastern Regions",
	LONDON: "London",
	SOUTHERN_REGION: "Southern Region",
	WESTERN_REGION: "Western Region",
	STAGES: "Stages",
	PRE_SEED: "Pre Seed",
	SEED: "Seed",
	SERIES_A: "Series A",
	SERIES_B: "Series B",
	LATE_STAGE: "Late Stage",
	BOOTSTRAPPED: "Bootstrapped",
	VC_STAGE: "VC Stage",
	PE_STAGE: "PE Stage",
	UNICORN: "Unicorn",
	ACQUISITION: "Acquisition",
	MERGER: "Merger",
	IPO: "IPO",
	SOONICORN: "Soonicorn",
	SPINOUT: "Spinout",
	ADTECH: "AdTech",
	AGRITECH: "AgriTech",
	DATA_ANALYTICS: "Data Analytics",
	ARTIFICIAL_INTELLIGENCE: "Artificial Intelligence",
	CLEANTECH: "CleanTech",
	EDTECH: "EdTech",
	AUTOMOTIVE_TECH: "Automotive Tech",
	ONLINE_PUBLISHING: "Online Publishing",
	FINTECH: "FinTech",
	FOODTECH: "FoodTech",
	CYBERSECURITY: "Cybersecurity",
	BIOTECHNOLOGY: "Biotechnology",
	ECOMMERCE: "E-Commerce",
	SAAS: "SaaS",
	DEVOPS: "DevOps",
	SOCIAL_COMMERCE: "Social Commerce",
	ELECTRIC_VEHICLE: "Electric Vehicle",
	INSURTECH: "InsurTech",
	ENERGY: "Energy",
	MEDTECH: "MedTech",
	HEALTHTECH: "HealthTech",
	INDUSTRIAL: "Industrial",
	LEGALTECH: "LegalTech",
	PROPTECH: "PropTech",
	FITNESS: "Fitness",
	METAVERSE: "Metaverse",
	VR: "VR",
	HR_TECH: "HR Tech",
	REGTECH: "RegTech",
	CRYPTOCURRENCY: "Cryptocurrency",
	LOGISTICS: "Logistics",
	GAMING: "Gaming",
	QUANTUM_COMPUTING: "Quantum Computing",
	TRANSPORT: "Transport",
	SUSTAINABILITY: "Sustainability",
	AVIATION_TECHNOLOGY: "Aviation Technology",
	CONSTRUCTIONTECH: "ConstructionTech",
	SPACETECH: "SpaceTech",
	ENTERTAINMENT: "Entertainment",
	RETAILTECH: "RetailTech",
	IOT: "IoT",
	TELECOM: "Telecom",
	WEB3: "Web3",
	CONSUMER: "Consumer",
	OTHER: "Other",
};

export const INDUSTRY = {
	ADTECH: "AdTech",
	AGRITECH: "AgriTech",
	DATA_ANALYTICS: "Data Analytics",
	ARTIFICIAL_INTELLIGENCE: "Artificial Intelligence",
	CLEANTECH: "CleanTech",
	EDTECH: "EdTech",
	AUTOMOTIVE_TECH: "Automotive Tech",
	ONLINE_PUBLISHING: "Online Publishing",
	FINTECH: "FinTech",
	FOODTECH: "FoodTech",
	CYBERSECURITY: "Cybersecurity",
	BIOTECHNOLOGY: "Biotechnology",
	ECOMMERCE: "E-Commerce",
	SAAS: "SaaS",
	DEVOPS: "DevOps",
	SOCIAL_COMMERCE: "Social Commerce",
	ELECTRIC_VEHICLE: "Electric Vehicle",
	INSURTECH: "InsurTech",
	ENERGY: "Energy",
	MEDTECH: "MedTech",
	HEALTHTECH: "HealthTech",
	INDUSTRIAL: "Industrial",
	LEGALTECH: "LegalTech",
	PROPTECH: "PropTech",
	FITNESS: "Fitness",
	METAVERSE: "Metaverse",
	VR: "VR",
	HR_TECH: "HR Tech",
	REGTECH: "RegTech",
	CRYPTOCURRENCY: "Cryptocurrency",
	LOGISTICS: "Logistics",
	GAMING: "Gaming",
	QUANTUM_COMPUTING: "Quantum Computing",
	TRANSPORT: "Transport",
	SUSTAINABILITY: "Sustainability",
	AVIATION_TECHNOLOGY: "Aviation Technology",
	CONSTRUCTIONTECH: "ConstructionTech",
	SPACETECH: "SpaceTech",
	ENTERTAINMENT: "Entertainment",
	RETAILTECH: "RetailTech",
	IOT: "IoT",
	TELECOM: "Telecom",
	WEB3: "Web3",
	CONSUMER: "Consumer",
	OTHER: "Other",
};
export const CATEGORY = {
	B2B: "B2B",
	B2C: "B2C",
	D2C: "D2C",
	D2B: "D2B",
};
export const BADGE = {
	OXBRIDGE_AND_BEYOND: "Oxbridge & Beyond",
	UNICORN_ALUMNI: "Unicorn Alumni",
	BIG_FOUR_VETERANS: "Big Four Veterans",
	AI_PIONEERS: "AI Pioneers",
	WEB3_BUILDERS: "Web3 Builders",
	ESG: "ESG",
	CREATIVE_POWERHOUSES: "Creative Powerhouses",
	RESEARCH_WIZARDS: "Research Wizards",
	SERIAL_FOUNDERS: "Serial Founders",
	HYPERGROWTH_NAVIGATORS: "Hypergrowth Navigators",
	REGIONAL_STARS: "Regional Stars",
	STUDENT_VISIONARIES: "Student Visionaries",
	FREELANCE_MAVERICKS: "Freelance Mavericks",
	SCALE_UP_HEROES: "Scale-up Heroes",
	TECH_POLICYMAKERS: "Tech Policymakers",
	ECOSYSTEM_CONNECTORS: "Ecosystem Connectors",
	PRIOR_EXITS: "Prior exits",
	DEEP_TECHNOLOGY_BACKGROUND: "Deep technology background",
	PRIOR_VC_BACKED_FOUNDER: "Prior VC backed founder",
	VENTURE_BACKED: "Venture backed",
	NORTHERN_REGION: "Northern region",
	EASTERN_REGION: "Eastern region",
	LONDON: "London",
	SOUTHERN_REGION: "Southern region",
	WESTERN_REGION: "Western region",
	STAGES: "Stages",
	PRE_SEED: "Pre seed",
	SEED: "Seed",
	SERIES_A: "Series A",
	SERIES_B: "Series B",
	LATE_STAGE: "Late stage",
	BOOTSTRAPPED: "Bootstrapped",
	VC_STAGE: "VC stage",
	PE_STAGE: "PE stage",
	UNICORN: "Unicorn",
	ACQUISITION: "Acquisition",
	MERGER: "Merger",
	IPO: "IPO",
	SOONICORN: "Soonicorn",
	SPINOUT: "Spinout",
	OTHER: "Other",
};
const createOptionsObj = <T extends Record<string, string>>(obj: T) =>
	Object.entries(obj).map(([value, label]) => ({
		label,
		value,
	}));


export const TAG_OPTIONS_OBJ = createOptionsObj(TAG);
export const INDUSTRY_OPTIONS_OBJ = createOptionsObj(INDUSTRY);
export const CATEGORY_OPTIONS_OBJ = createOptionsObj(CATEGORY);
export const BADGE_OPTIONS_OBJ = createOptionsObj(BADGE);


export const IndustryIO = t.keyof(INDUSTRY);
export const CompanyTagIO = t.keyof(TAG);
export const BadgeTagIO = t.keyof(BADGE)

export type IndustryTagT = t.TypeOf<typeof IndustryIO>;
export type CompanyTagT = t.TypeOf<typeof CompanyTagIO>;
export type BadgeTagT = t.TypeOf<typeof BadgeTagIO>;

export type CompanyCategoryT = {
	key: MarketCapT;
	label: string;
	icon: string;
  };
export const companyCategories: CompanyCategoryT[] = [
  { key: "msme", label: "MSME", icon: "office" },
  { key: "startup", label: "Startup", icon: "rocket-slant" },
  { key: "largecap", label: "LargeCap", icon: "bank-account" },
];
const marketCapitals = ["msme", "startup", "largecap"] as const;
export type MarketCapT = (typeof marketCapitals)[number];

